import { useEffect, useState } from "react"
import SegmentForm from "./config/SegmentForm.jsx"
import EnrichmentForm from "./config/EnrichmentForm.jsx"
import EmailCampaignForm from "./config/EmailCampaignForm.jsx"

const FORMS = {
  "input.segment": SegmentForm,
  "enrichment.lead": EnrichmentForm,
  "enrichment.company": EnrichmentForm,
  "outreach.email_campaign": EmailCampaignForm
}

// Slides in from the right when a node is clicked in edit mode. The
// per-step-type form mutates an in-memory `config` draft. Clicking OK
// hands the draft back to the canvas — the actual server write happens
// when the user clicks Save in the page header.
export default function ConfigPanel({ node, options, onClose, onCommit }) {
  const Form = FORMS[node.data.stepType] ?? null
  const [config, setConfig] = useState(node.data.config ?? {})

  useEffect(() => {
    setConfig(node.data.config ?? {})
  }, [node.id])

  // Header Save click dispatches gtm:flush-config — treat it like an OK
  // so the draft makes it into the diff. Listener is re-registered when
  // `config` changes so it captures the latest draft.
  useEffect(() => {
    const handler = () => onCommit(config)
    window.addEventListener("gtm:flush-config", handler)
    return () => window.removeEventListener("gtm:flush-config", handler)
  }, [config, onCommit])

  return (
    <aside className="absolute top-0 right-0 bottom-0 w-80 z-20 bg-card border-l border-border shadow-xl flex flex-col">
      <header className="flex items-center justify-between px-4 py-3 border-b border-border">
        <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground">
          {node.data.stepTypeLabel}
        </p>
        <button type="button" onClick={onClose}
                className="h-7 w-7 rounded-md hover:bg-muted/40 flex items-center justify-center text-muted-foreground">
          ×
        </button>
      </header>

      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        {Form
          ? <Form node={node} options={options} config={config} setConfig={setConfig} />
          : <p className="text-xs text-muted-foreground">No config UI for this step type yet.</p>}
      </div>

      <footer className="px-4 py-3 border-t border-border flex justify-end gap-2">
        <button type="button" onClick={onClose}
                className="h-9 px-3 rounded-lg border border-border bg-background text-sm hover:border-primary transition-colors">
          Cancel
        </button>
        <button type="button" onClick={() => onCommit(config)}
                className="h-9 px-4 rounded-lg gradient-primary text-primary-foreground text-sm font-semibold shadow-md">
          OK
        </button>
      </footer>
    </aside>
  )
}
